import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./puertas-seguridad.css";
import door1 from "./img-domotic/puertas_seguridad.png"
import door2 from "./img-domotic/puertas_seguridad_2.png"
import door3 from "./img-domotic/puertas_seguridad.png"

import assaabloy from "./img-domotic/puertas_seguridad.png"
import dormakaba from "./img-domotic/puertas_seguridad.png"
import mul_t_lock from "./img-domotic/puertas_seguridad.png"
import salto from "./img-domotic/puertas_seguridad.png"

const SecurityDoors = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Puertas de Seguridad
  const imagenesGaleria = [
    { src: door1, alt: "Puerta blindada de alta seguridad", caption: "Protección certificada contra intrusiones" },
    { src: door2, alt: "Puerta antibalas", caption: "Solución para protección extrema" },
  ];

  const servicios = [
    {
      icon: "🚪",
      titulo: "Puertas Blindadas",
      descripcion: "Fabricación e instalación de puertas con certificación RC2 a RC6.",
      features: ["Acero antibumping", "Cerraduras multipunto", "Juntas anti-palanca"]
    },
    {
      icon: "🔒",
      titulo: "Sistemas de Cierre",
      descripcion: "Cerraduras de alta seguridad y electrónicas con control avanzado.",
      features: ["Cilindros antibumping", "Claves dinámicas", "Control maestro"]
    },
    {
      icon: "👁️",
      titulo: "Control de Acceso",
      descripcion: "Integración con sistemas electrónicos para gestión de permisos.",
      features: ["Reconocimiento facial", "Tarjetas RFID", "Control horario"]
    },
    {
      icon: "🛡️",
      titulo: "Protección Especial",
      descripcion: "Soluciones para requerimientos de seguridad extrema.",
      features: ["Puertas acorazadas", "Resistencia balística", "Protección anti-saw"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Residencial",
      items: [
        "Puertas de entrada blindadas",
        "Sistemas para apartamentos",
        "Portones de seguridad",
        "Cerraduras inteligentes"
      ]
    },
    {
      categoria: "Comercial",
      items: [
        "Accesos corporativos",
        "Puertas para bancos",
        "Joyelerías y farmacias",
        "Control de inventarios"
      ]
    },
    {
      categoria: "Institucional",
      items: [
        "Protección para embajadas",
        "Centros de datos",
        "Laboratorios",
        "Áreas restringidas"
      ]
    }
  ];

  const marcas = [
    { nombre: "ASSA ABLOY", logo: assaabloy },
    { nombre: "Dormakaba", logo: dormakaba },
    { nombre: "Mul-T-Lock", logo: mul_t_lock },
    { nombre: "SALTO", logo: salto },
    { nombre: "Medeco", logo: "/marcas/medeco.png" },
    { nombre: "Kaba", logo: "/marcas/kaba.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.doors-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="doors-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="doors-hero">
        <div className="doors-hero-content">
          <h1 className="doors-hero-title">Puertas de Seguridad</h1>
          <p className="doors-hero-subtitle">
            Protección certificada para propiedades y activos críticos
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="doors-gallery doors-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="doors-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="doors-gallery-img"
            />
            <div className="doors-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

         {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Puertas de Seguridad</h2>
    <p className="ryn-features-subtitle">Tecnología avanzada en Puertas de Seguridad Empresarial</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">PUERTAS DE SEGURIDAD </h3>
          <ul className="ryn-feature-list">
            <li>Puertas Uso Hospitalario y sector alimenticio: manuales y automatizadas</li>
            <li>Puertas cortafuego  y accesorios</li>
          </ul>
        </div>
      </div>
      
  
    </div>
  </div>
</section>  




    </div>
  );
};

export default SecurityDoors;